/* eslint-disable no-console */
const { REACT_APP_LOG_LEVEL } = window;

export default () => {
  const log = (level, source, message) => {
    const dateString = new Date().toISOString();
    switch (level) {
      case 3:
        console.error(`${dateString} ERROR ${source} ${message}`);
        break;
      case 4:
        console.warn(`${dateString} WARN ${source} ${message}`);
        break;
      case 6:
        console.info(`${dateString} INFO ${source} ${message}`);
        break;
      case 7:
        console.debug(`${dateString} DEBUG ${source} ${message}`);
        break;
      default:
        console.warn(
          `${dateString} WARN LogLevel '${level}' not supported. Use 3 (error), 4 (warn), 6 (info) or 7 (debug) to see logs`
        );
        break;
    }
  };

  const debug = (source, message) => {
    if (parseInt(REACT_APP_LOG_LEVEL, 10) === 7) {
      log(7, source, message);
    }
  };

  const info = (source, message) => {
    if (parseInt(REACT_APP_LOG_LEVEL, 10) >= 6) {
      log(6, source, message);
    }
  };

  const warn = (source, message) => {
    if (parseInt(REACT_APP_LOG_LEVEL, 10) >= 4) {
      log(4, source, message);
    }
  };

  const error = (source, message) => {
    if (parseInt(REACT_APP_LOG_LEVEL, 10) >= 3) {
      log(3, source, message);
    }
  };

  return {
    debug,
    info,
    warn,
    error,
  };
};
